import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-glow"></div>
      <div className="footer-inner section-wrapper">
        <div className="footer-top">
          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <svg viewBox="0 0 60 60" fill="none" width="40" height="40">
                <circle cx="30" cy="14" r="3" stroke="#00d4d4" strokeWidth="1.5"/>
                <circle cx="14" cy="42" r="3" stroke="#00d4d4" strokeWidth="1.5"/>
                <circle cx="46" cy="42" r="3" stroke="#00d4d4" strokeWidth="1.5"/>
                <line x1="30" y1="17" x2="30" y2="48" stroke="#00d4d4" strokeWidth="2"/>
                <line x1="30" y1="22" x2="13" y2="40" stroke="#00d4d4" strokeWidth="1.5"/>
                <line x1="30" y1="22" x2="47" y2="40" stroke="#00d4d4" strokeWidth="1.5"/>
                <line x1="30" y1="28" x2="11" y2="28" stroke="#00d4d4" strokeWidth="1.5"/>
                <line x1="30" y1="28" x2="49" y2="28" stroke="#00d4d4" strokeWidth="1.5"/>
                <path d="M18 52 Q30 48 42 52" stroke="#00d4d4" strokeWidth="1.5" fill="none"/>
              </svg>
              <div>
                <span className="footer-logo-name">VistaraKlyQs</span>
                <span className="footer-logo-sub">TECH LLP</span>
              </div>
            </Link>
            <p className="footer-tagline">Expand · Innovate · Transform</p>
            <p className="footer-desc">
              Building AI-first products, scalable cloud platforms, and mobile apps for businesses worldwide.
            </p>
          </div>

          {/* Links */}
          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/services">Services</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="footer-col">
            <h4>Services</h4>
            <Link to="/services">AI Agents</Link>
            <Link to="/services">Chatbot Dev</Link>
            <Link to="/services">Web Apps</Link>
            <Link to="/services">Mobile Apps</Link>
            <Link to="/services">Healthcare Apps</Link>
            <Link to="/services">Insurance Platforms</Link>
          </div>

          <div className="footer-col">
            <h4>Technologies</h4>
            <span>AWS · Azure · GCP</span>
            <span>React · Node.js · MongoDB</span>
            <span>Docker · Kubernetes</span>
            <span>Python · PostgreSQL</span>
            <span>Gen AI · LangChain</span>
            <span>Jenkins · CI/CD</span>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {year} VistaraKlyQs Tech LLP. All rights reserved.</p>
          <div className="footer-legal">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
